import IconFireSolid from '@/assets/icons/font_awesome/fire-solid.svg?react';
import IconHeartSolid from '@/assets/icons/font_awesome/heart-solid.svg?react';
import IconUploadSolid from '@/assets/icons/font_awesome/upload-solid.svg?react';
import { ICON__magnifying_glass } from '@/assets/icons_fa';
import { use_slice_collections } from '@/hooks/store/use_slices';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { useTranslation } from 'react-i18next';
import { SEPARATOR__horizontal } from '../../_base/separators/SEPARATOR__horizontal';
import { SEPARATOR__horizontal_dashed } from '../../_base/separators/SEPARATOR__horizontal_dashed';
import { C_LIST_ITEM__collection_special } from '../list/C_LIST_ITEM__collection_special';
import { C_LIST__collection } from '../list/C_LIST__collection';
import { C_BAR__collections_actions } from './C_BAR__collections_actions';

export function C_SIDEBAR__collections() {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_COLLECTIONS);

  const { collections_map } = use_slice_collections(['collections_map']);
  const { collection_uploads, collection_viewed_on_search, collection_generated, collection_favorites } = use_slice_collections([
    'collection_uploads',
    'collection_viewed_on_search',
    'collection_generated',
    'collection_favorites',
  ]);

  function render_special_items_and_first_list() {
    return (
      <>
        <div className=" flex flex-col py-2 bg-component">
          <C_LIST_ITEM__collection_special entity={collection_generated} Icon={IconFireSolid} />
          <C_LIST_ITEM__collection_special entity={collection_viewed_on_search} Icon={ICON__magnifying_glass} />

          <span className="pt-2" />
          <SEPARATOR__horizontal />
          <span className="pt-2" />

          <C_LIST_ITEM__collection_special entity={collection_favorites} Icon={IconHeartSolid} />
          <C_LIST_ITEM__collection_special entity={collection_uploads} Icon={IconUploadSolid} />
        </div>

        <SEPARATOR__horizontal_dashed />

        <C_LIST__collection />
      </>
    );
  }

  function render_items() {
    if (collections_map.size == 0) return null;

    return <>{render_special_items_and_first_list()}</>;
  }

  return (
    <div className="flex flex-col size-full bg-bar">
      <C_BAR__collections_actions />
      {render_items()}
    </div>
  );
}
